<div id="dialog-container">
  <h1 mat-dialog-title>{{ 'TITLE.ADD_PROJECT_TO_WORKS' | translate }}</h1>

  <mat-divider></mat-divider>

  <mat-dialog-content class="creation-dialog-no-stepper fx-flex-auto">
    <div class="form-container">
      <form [formGroup]="workForm">
        <div class="project-form-field">

          @if (assetIds.length > 0) {
            <mat-form-field appearance="outline" [hidden]="!inputField.hasData">
              <mat-label>{{ 'LABEL.PROJECT' | translate }}</mat-label>
              <mat-select-project-autocomplete #inputField formControlName="project" [assetIds]="assetIds" required>
              </mat-select-project-autocomplete>

              @if (workForm.controls.project.hasError('required')) {
                <mat-error
                  class="small-font text-danger support-text">
                  {{ 'ERROR.FIELD_REQUIRED' | translate }}
                </mat-error>
              }
            </mat-form-field>
            @if (inputField.ready && !inputField.hasData) {
              {{ 'LABEL.NO_RELATED_PROJECTS' | translate }}
            }
          } @else {
            <div class="field-container fx-flex-100-66-percent-min-500">
              <p id="no-asset-selected-message">
                {{ 'LABEL.NO_ASSET_SELECTED' | translate }}
              </p>
            </div>
          }
        </div>
      </form>

      <div class="button-container fx-layout-row fx-justify-end fx-align-center">
        <button mat-stroked-button [id]="'update-work-cancel-button'" matDialogClose="cancel">
          {{ 'BUTTON.CANCEL' | translate }}
        </button>
        <button mat-raised-button [id]="'update-work-add-button'" [disabled]="workForm.invalid" color="accent"
                matDialogClose="yes">
          {{ 'BUTTON.SAVE' | translate }}
        </button>
      </div>
    </div>
  </mat-dialog-content>
</div>
